import { useStaticQuery, graphql } from "gatsby"

const useLayoutQuery = () => {
  return useStaticQuery(graphql`
    fragment WpSeo on WpPostTypeSEO {
      metaDesc
      metaKeywords
      metaRobotsNofollow
      opengraphAuthor
      opengraphDescription
      opengraphImage {
        localFile {
          publicURL
        }
      }
      opengraphModifiedTime
      opengraphPublishedTime
      opengraphPublisher
      opengraphSiteName
      opengraphTitle
      opengraphType
      opengraphUrl
      readingTime
      schema {
        articleType
        pageType
        raw
      }
      title
      twitterDescription
      twitterImage {
        localFile {
          publicURL
        }
      }
      twitterTitle
    }
    fragment ArticleCard on WpPost {
      id
      uri
      title
      content
      excerpt
      date(formatString: "ddd DD MMMM")
    }
    fragment TeamCard on WpTeam {
      title
      uri
      id
      acf {
        cardImage {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1000)
            }
          }
        }
        position
        snippet
      }
    }
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      wp {
        siteOptions {
          acf {
            headerMenu {
              link {
                url
                title
              }
              subMenu {
                link {
                  url
                  title
                }
              }
            }
            footerMenu {
              link {
                url
                title
              }
              subMenu {
                link {
                  url
                  title
                }
              }
            }
            social {
              link {
                url
                title
              }
            }
            address
            phone {
              url
              title
            }
            email {
              url
              title
            }
          }
        }
        generalSettings {
          title
          url
        }
      }
    }
  `)
}

export default useLayoutQuery